module.exports = __webpack_public_path__ + "static/media/add.99972375.svg";